<form #appEnvForm="ngForm" class="mt-10">
  <table class="wm-table property-value">
    <tbody>
    <tr>
      <th>{{locale.LABEL_KEY}}</th>
      <th>{{locale.LABEL_VALUE}}</th>
      <th>&nbsp;</th>
    </tr>
    <tr *ngFor="let prop of appEnvironmentProps">
      <td name="wm-existing-app-param">
        <label class="control-label app-label">{{prop.key}}</label>
      </td>
      <td>
        <input class="form-control app-textbox app-widget-wrapper"
               [name]="'wm-app-environment-' + prop.value"
               (change)="editAppEnvironmentProperty(prop)"
               [(ngModel)]="prop.value"
               [ngModelOptions]="{updateOn: 'change'}">
      </td>
      <td>
        <button type="button" name="wm-input-param-remove-sample" (click)="deleteEnvironmentParams(prop)" class="btn btn-transparent"><i class="wms wms-delete"></i></button>
      </td>
    </tr>
    <tr>
      <td name="wm-new-input-app-param">
        <input class="form-control app-textbox app-widget-wrapper" [ngClass]="{'error' : errorKey}"
               name="wm-new-input-app-param-key" type="text" placeholder="{{locale.LABEL_KEY}}"
               [ngModelOptions]="{updateOn: 'change'}" [(ngModel)]="appEnvironment.key">
      </td>
      <td>
        <input class="form-control app-textbox app-widget-wrapper" [ngClass]="{'error' : errorValue}"
               name="wm-new-input-app-param-value" type="text" placeholder="{{locale.LABEL_VALUE}}"
               [ngModelOptions]="{updateOn: 'change'}" [(ngModel)]="appEnvironment.value">
      </td>
      <td>
        <button type="button" name="wm-new-input-param-add" class="btn btn-transparent" (click)="addNewEnvironmentParams()"><i class="wms wms-plus"></i></button>
      </td>
    </tr>
    </tbody>
  </table>
</form>
